import { panggilSuara, suaraDariLabel } from '../../../utils/suaraAntrian';
import CampaignOutlined from '@mui/icons-material/CampaignOutlined';
import { labelAntrian } from '../../../utils/antrian';
import { konfirmasi } from '../../../utils/dialog';
import { batalkanQrisBelumBayar, PESAN_BATAL_QRIS } from '../batalQris';
import { barisStrukKasir } from '../../../struk/strukWeb';
import { cetakBrowser } from '../../../struk/cetakStruk';
import { bacaLaci, harusBukaLaciOtomatis } from '../../../struk/laciKasir';
import StrukPratinjau from '../../../struk/StrukPratinjau';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { bacaTingkat, hargaDasarKeranjang } from '../../../utils/hargaGrosir';
import { useLayarPelanggan } from '../../../hooks/useLayarPelanggan';
import { infoCabang, pesanKeranjang, pesanQris, pesanSelesai } from '../../../utils/layarPelanggan';
import axios from 'axios';
import ZoomableImage from '../ZoomableImage';
import {
  Alert,
  AppBar,
  Badge,
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid, 
  IconButton,
  InputAdornment,
  MenuItem,
  Paper,
  Select,
  Snackbar,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {
  CloseOutlined as CloseIcon,
  HomeOutlined,
  Notifications as NotificationsIcon,
  PersonOutlined,
  PrintOutlined,
  QrCode2Outlined,
  ReceiptOutlined,
  ViewListOutlined,
  ViewModuleOutlined,
} from '@mui/icons-material';
import { MagnifyingGlass, ShoppingCart } from '@phosphor-icons/react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import ThermalPrinter from '../ThermalPrinter';
import TombolBukaLaci from '../TombolBukaLaci';
import ReservasiBayarPanel from '../ReservasiBayarPanel';
import { reservasiPerMeja } from '../../../utils/reservasiMeja';
import { hitungReservasiBayar, reservasiBayarAwal, reservasiBerdp, reservasiUntukMeja } from '../../../utils/reservasiBayar';
import BagiBayarPanel from '../BagiBayarPanel';
import DpPanel from '../DpPanel';
import KuponPanel from '../KuponPanel';
import { bagiAwal, hitungBagi } from '../../../utils/bagiBayar';
import { dpAwal, hitungDp } from '../../../utils/uangMuka';
import { Logout, reset } from '../../../fitur/AuthSlice';
import {
  createCustomer,
  fetchCabangConfig,
  fetchCustomerCategories,
  fetchCustomers,
  fetchMe,
  fetchNonCashMethods,
  fetchPengaturanUtama,
  fetchProductsAndCategories,
  fetchTables,
  fetchTakeaway,
  getApiBaseUrl,
} from './apiProductPercabang';
import CardProductPercabang from './cardProductPercabang';
import CartProductPercabang from './cartProductPercabang';
import ProductOptionsDialogKasir from './ProductOptionsDialogKasir';
import { useMidtransCabang } from '../../integrasi/useMidtransCabang';
import QrisKasir from '../QrisKasir';
import {
  CategoryChip,
  FloatingCartButton,
  POS_BG,
  POS_BORDER,
  POS_PRIMARY,
  POS_PRIMARY_HOVER,
} from './stylesProductPercabang';
import { KartuShiftWeb, useShiftKasir } from '../../shift/ShiftKasirWeb';

export default function LayoutProductPercabang() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tables, setTables] = useState([]);
  const [takeawayList, setTakeawayList] = useState([]);
  const [selectedTakeawayName, setSelectedTakeawayName] = useState(null);
  const [nonCashMethods, setNonCashMethods] = useState([]);
  const [selectedNonCashMethodUuid, setSelectedNonCashMethodUuid] = useState('');
  const [bagi, setBagi] = useState(bagiAwal()); // pembayaran bagi (tunai + non-tunai)
  const [dp, setDp] = useState(dpAwal()); // uang muka (DP) + piutang pelanggan
  const [cabangConfig, setCabangConfig] = useState(null);
  const [utamaConfig, setUtamaConfig] = useState(null);
  const [orders, setOrdersMentah] = useState([]);
  // Harga grosir bertingkat: setiap perubahan keranjang menghitung ulang harga satuan menurut total unit tiap produk
  // (utils/hargaGrosir.js; server menghitung ulang saat transaksi disimpan).
  const setOrders = useCallback((pembaruan) => {
    setOrdersMentah((prev) => {
      const berikut = typeof pembaruan === 'function' ? pembaruan(prev) : pembaruan;
      const dasar = hargaDasarKeranjang(berikut.map((o) => ({ id: o.baranguuid, harga: o.hargaDasar, hargaGrosir: o.hargaGrosir, jumlah: o.quantity })));
      return berikut.map((o) => {
        if (o.hargaDasar === undefined) return o;
        const harga = dasar.get(o.baranguuid);
        const price = harga + (o.opsiHarga || 0);
        return o.price === price && o.grosir === (harga < o.hargaDasar) ? o : { ...o, price, grosir: harga < o.hargaDasar };
      });
    });
  }, []);
  const [optionsDialogProduct, setOptionsDialogProduct] = useState(null);
  const orderLineIdRef = useRef(0);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [productViewMode, setProductViewMode] = useState('grid');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [mobileCartOpen, setMobileCartOpen] = useState(false);

  const RIGHT_DRAWER_W = 460;

  const [metode_pesanan, setMetode_pesanan] = useState('dinein');
  const [noted, setNoted] = useState('');
  const [selectedTableId, setSelectedTableId] = useState(null);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('cash');
  // DP reservasi: reservasi aktif yang DP-nya sudah diterima (dimuat saat dialog pembayaran dibuka) dan pilihan kasir.
  const [reservasiDpList, setReservasiDpList] = useState([]);
  const [reservasiBayar, setReservasiBayar] = useState(reservasiBayarAwal());
  // Semua reservasi aktif hari ini (untuk menandai meja yang sedang dipakai tamu reservasi di pilihan meja); diperbarui tiap menit.
  const [reservasiAktif, setReservasiAktif] = useState([]);
  const reservasiMeja = useMemo(() => reservasiPerMeja(reservasiAktif, new Date()), [reservasiAktif]);
  const reservasiQrisRef = useRef(null); // { baris, kode } selama QRIS sisa tagihan (DP reservasi) menunggu bayar
  // Promo otomatis: dihitung server (POST /promo/hitung) dari isi keranjang; server menghitung ulang saat transaksi disimpan.
  const [promo, setPromo] = useState({ diskonTotal: 0, promo: null });
  const [kodeKupon, setKodeKupon] = useState(''); // kupon yang diketik kasir (server memeriksa & menghitung; boleh ditumpuk dengan promo otomatis)
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [customerCash, setCustomerCash] = useState('');

  const [paymentStatus, setPaymentStatus] = useState('idle');
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [orderId, setOrderId] = useState('');
  const [receiptPreviewOpen, setReceiptPreviewOpen] = useState(false);
  const [receiptPreviewData, setReceiptPreviewData] = useState(null);
  const [isPrinting, setIsPrinting] = useState(false);
  const [branchName, setBranchName] = useState('Nama Toko');
  const [showPrinterSettings, setShowPrinterSettings] = useState(false);
  const [printerConnected, setPrinterConnected] = useState(false);
  const [printerInstance, setPrinterInstance] = useState(null);
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'info' });
  const adalahKasir = user?.role === 'kasir';
  const shiftHook = useShiftKasir(adalahKasir);
  const [mintaShift, setMintaShift] = useState(false);
  const [mintaTutupShift, setMintaTutupShift] = useState(false);
  const productSearchInputRef = useRef(null);
  const paymentPollingRef = useRef(null);
  const qrisUuidRef = useRef(null); // transaksi QRIS yang sudah dibuat tetapi belum lunas/dibatalkan
  const antrianQrisRef = useRef(''); // nomor antrian pesanan QRIS yang sedang menunggu pembayaran

  // Customer
  const [customers, setCustomers] = useState([]);
  const [customerCategories, setCustomerCategories] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customerSearchTerm, setCustomerSearchTerm] = useState('');
  const [showCustomerDialog, setShowCustomerDialog] = useState(false);
  const [showCreateCustomerDialog, setShowCreateCustomerDialog] = useState(false);
  const customerSearchInputRef = useRef(null);
  const ignoreNextCustomerFocusRef = useRef(false);
  const [newCustomer, setNewCustomer] = useState({
    nama: '',
    telepon: '',
    email: '',
    alamat: '',
    kategoriCustomerUuid: '',
  });

  // Header clock
  const [headerClock, setHeaderClock] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setHeaderClock(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'F1') {
        e.preventDefault();
        productSearchInputRef.current?.focus?.();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const [{ products: p, categories: c }, me, meja, takeaway, nonCash] = await Promise.all([
          fetchProductsAndCategories(),
          fetchMe(),
          fetchTables(),
          fetchTakeaway(),
          fetchNonCashMethods(),
        ]);
        setProducts(p);
        setCategories(c);
        setTables(meja);
        setTakeawayList(takeaway);
        setNonCashMethods(nonCash);
        setBranchName(me?.cabang?.namacabang || 'Nama Toko');
        if (user?.cabang?.uuid) {
          const config = await fetchCabangConfig(user.cabang.uuid);
          setCabangConfig(config);
        }
        const utama = await fetchPengaturanUtama();
        setUtamaConfig(utama);
      } catch (e) {
        setError(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [user?.cabang?.uuid]);

  useEffect(() => {
    (async () => {
      try {
        const [cats, cust] = await Promise.all([fetchCustomerCategories(), fetchCustomers('')]);
        setCustomerCategories(cats);
        setCustomers(cust);
      } catch {
        // ignore
      }
    })();
  }, []);

  const formatCurrency = (value) => {
    const v = typeof value === 'string' ? parseFloat(value) : value;
    return typeof v === 'number' && !Number.isNaN(v) ? v.toLocaleString('id-ID') : '0';
  };

  const subtotal = useMemo(() => orders.reduce((sum, o) => sum + o.price * o.quantity, 0), [orders]);
  const diskonPromo = promo.diskonTotal || 0;
  const promoNama = [promo.promo?.nama, promo.kupon ? `Kupon ${promo.kupon.kode}` : ''].filter(Boolean).join(' + '); // sama dengan nama di transaksi
  const kuponBermasalah = !!(kodeKupon && promo.kuponGalat);
  const discountedSubtotal = Math.max(0, subtotal - diskonPromo);
  const ppnAktif = cabangConfig?.ppnAktif === true;
  const ppnPersenValue = parseFloat(cabangConfig?.ppnPersen) || 0;
  const ppnNominal = ppnAktif && ppnPersenValue > 0 ? Math.round((discountedSubtotal * ppnPersenValue) / 100) : 0;
  const total = discountedSubtotal + ppnNominal;

  // Hitung promo otomatis tiap isi keranjang berubah (ditunda 300 ms). Gagal / tanpa promo = tanpa potongan.
  useEffect(() => {
    if (orders.length === 0) { setPromo({ diskonTotal: 0, promo: null }); return undefined; }
    let batal = false;
    const t = setTimeout(() => {
      axios.post(`${getApiBaseUrl()}/promo/hitung`, {
        items: orders.map((o) => ({ baranguuid: o.baranguuid, total: o.price * o.quantity })),
        ...(kodeKupon ? { kodeKupon } : {}),
        ...(selectedCustomer?.uuid ? { customerUuid: selectedCustomer.uuid } : {}), // promo ulang tahun & batas per pelanggan
      }, { withCredentials: true })
        .then((r) => { if (!batal) setPromo(r.data?.data || { diskonTotal: 0, promo: null }); })
        .catch(() => { if (!batal) setPromo({ diskonTotal: 0, promo: null }); });
    }, 300);
    return () => { batal = true; clearTimeout(t); };
  }, [orders, kodeKupon, selectedCustomer]);
  useEffect(() => { if (!paymentDialogOpen) setKodeKupon(''); }, [paymentDialogOpen]);

  // Label meja/nama takeaway untuk struk (sama dengan struk di aplikasi kasir Flutter).
  const labelMejaStruk = () => {
    if (metode_pesanan === 'takeaway') return selectedTakeawayName || '';
    const t = tables.find((x) => x.uuid === selectedTableId || x.id === selectedTableId);
    return t ? (t.name || t.nomeja || '') : '';
  };

  const toUploadUrl = (fileName) => (fileName ? `${getApiBaseUrl()}/uploads/${fileName}` : null);
  const receiptLogoUrl =
    (cabangConfig?.logoTampilStruk !== false && cabangConfig?.logo && toUploadUrl(cabangConfig.logo)) ||
    toUploadUrl(utamaConfig?.logo) ||
    null;
  // QRIS butuh saklar global aktif dan akun Midtrans untuk cabang ini.
  const midtransCabang = useMidtransCabang(user?.cabang?.uuid);
  const qrisEnabled = utamaConfig?.qrisAktif !== false && midtransCabang;

  // Layar pelanggan (halaman /layar di server, dibuka dari tombol Layar Pelanggan): belanjaan & total, QR QRIS, lalu terima kasih + kembalian.
  const kirimLayar = useLayarPelanggan();
  const cabangLayar = useMemo(() => infoCabang({ nama: branchName, logo: receiptLogoUrl || '' }), [branchName, receiptLogoUrl]);
  useEffect(() => {
    if (qrCodeUrl) { kirimLayar(pesanQris({ qris: qrCodeUrl, total }, cabangLayar)); return; }
    kirimLayar(pesanKeranjang({
      items: orders.map((o) => ({ nama: o.name, harga: o.price, qty: o.quantity, grosir: o.grosir, catatan: o.catatan, opsi: (o.selectedOptions || []).map((x) => x.opsinama).join(', ') })),
      subtotal, diskon: diskonPromo, promoNama, ppnPersen: ppnPersenValue, ppnNominal, total,
    }, cabangLayar));
  }, [orders, total, subtotal, diskonPromo, promoNama, ppnPersenValue, ppnNominal, qrCodeUrl, cabangLayar, kirimLayar]);
  useEffect(() => {
    if (!receiptPreviewData) return;
    kirimLayar(pesanSelesai({
      total: receiptPreviewData.total, bayar: receiptPreviewData.customerCash, kembalian: receiptPreviewData.change,
      metode: receiptPreviewData.paymentMethod, nomorAntrian: receiptPreviewData.nomorAntrian,
    }, cabangLayar));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [receiptPreviewData]);

  useEffect(() => {
    if (!qrisEnabled && selectedPaymentMethod === 'qris') {
      setSelectedPaymentMethod('cash');
    }
  }, [qrisEnabled, selectedPaymentMethod]);

  const filteredProducts = useMemo(() => {
    return products.filter((product) => {
      const matchesCategory =
        !selectedCategory || product?.Barang?.Kategori?.namakategori === selectedCategory;
      const matchesSearch =
        !searchTerm ||
        product?.Barang?.namabarang?.toLowerCase().includes(searchTerm.toLowerCase());
      return matchesCategory && matchesSearch;
    });
  }, [products, selectedCategory, searchTerm]);

  // Setiap kali dipanggil selalu jadi baris keranjang baru (tidak digabung
  // ke baris yang sudah ada) supaya tiap unit bisa punya opsi/catatan
  // sendiri-sendiri (mis. Level Pedas, Es, atau catatan bebas). Kalau mau
  // beberapa unit dengan opsi yang sama, tinggal naikkan quantity baris itu.
  // Dua baris dianggap sama persis kalau produk, catatan, dan kombinasi opsinya identik
  // (urutan opsi tidak masalah) -> baris begini digabung quantity-nya, bukan ditumpuk.
  const sameOrderLine = (o, note, selectedOptions) => {
    if ((o.catatan || '') !== (note || '')) return false;
    const aIds = (o.selectedOptions || []).map((opt) => opt.optionUuid).sort();
    const bIds = (selectedOptions || []).map((opt) => opt.optionUuid).sort();
    return aIds.length === bIds.length && aIds.every((id, i) => id === bIds[i]);
  };

  const addToOrder = (product, { quantity = 1, note = '', selectedOptions = [] } = {}) => {
    const stok = parseInt(product?.stok || 0, 10);
    if (Number.isNaN(stok) || stok <= 0) {
      setNotification({ open: true, message: 'Stok produk habis!', severity: 'error' });
      return;
    }
    const currentQtyForProduct = orders
      .filter((o) => o.baranguuid === product.baranguuid)
      .reduce((sum, o) => sum + o.quantity, 0);
    if (currentQtyForProduct + quantity > stok) {
      setNotification({ open: true, message: 'Stok tidak mencukupi!', severity: 'warning' });
      return;
    }
    const optionsPrice = selectedOptions.reduce((sum, o) => sum + (o.hargatambahan || 0), 0);
    setOrders((prev) => {
      const existingIndex = prev.findIndex(
        (o) => o.baranguuid === product.baranguuid && sameOrderLine(o, note, selectedOptions)
      );
      if (existingIndex !== -1) {
        return prev.map((o, i) => (i === existingIndex ? { ...o, quantity: o.quantity + quantity } : o));
      }
      orderLineIdRef.current += 1;
      return [
        ...prev,
        {
          id: `${product.baranguuid}-${orderLineIdRef.current}`,
          baranguuid: product.baranguuid,
          name: product.Barang.namabarang,
          price: parseFloat(product.Barang.harga) + optionsPrice,
          hargaDasar: parseFloat(product.Barang.harga),
          opsiHarga: optionsPrice,
          hargaGrosir: bacaTingkat(product.hargaGrosir),
          quantity,
          catatan: note,
          selectedOptions,
        },
      ];
    });
  };

  const handleProductAdd = (product) => {
    const hasOptions = (product.Barang?.BarangOpsiGrups || []).length > 0;
    if (hasOptions) {
      setOptionsDialogProduct(product);
    } else {
      addToOrder(product);
    }
  };

  const updateOrderNote = (id, catatan) =>
    setOrders((prev) => prev.map((o) => (o.id === id ? { ...o, catatan } : o)));

  const removeOrder = (id) => setOrders((prev) => prev.filter((o) => o.id !== id));
  const decrementLocalStock = (soldItems) => {
    if (!Array.isArray(soldItems) || soldItems.length === 0) return;
    setProducts((prev) =>
      prev.map((product) => {
        const soldQty = soldItems
          .filter((it) => it.baranguuid === product.baranguuid)
          .reduce((sum, it) => sum + it.quantity, 0);
        if (soldQty === 0) return product;
        const current = parseInt(product.stok || 0, 10);
        const nextStock = Number.isNaN(current) ? 0 : Math.max(0, current - soldQty);
        return { ...product, stok: String(nextStock) };
      })
    );
  };

  const incrementOrder = (id) => {
    setOrders((prev) =>
      prev.map((o) => {
        if (o.id !== id) return o;
        const product = products.find((p) => p.baranguuid === o.baranguuid);
        const stok = parseInt(product?.stok || 0, 10);
        if (o.quantity >= stok) {
          setNotification({ open: true, message: 'Stok tidak mencukupi!', severity: 'warning' });
          return o;
        }
        return { ...o, quantity: o.quantity + 1 };
      })
    );
  };

  const decrementOrder = (id) =>
    setOrders((prev) =>
      prev.map((o) => (o.id === id && o.quantity > 1 ? { ...o, quantity: o.quantity - 1 } : o))
    );

  const [currentView, setCurrentView] = useState('home');
  useEffect(() => {
    const path = location.pathname;
    if (path === '/produkpercabang') setCurrentView('home');
    else if (path === '/transaksikasir') setCurrentView('history');
    else if (path === '/notification' || path === '/notification-kasir') setCurrentView('notification');
    else if (path === '/detail' || path === '/detail-kasir') setCurrentView('detail');
    else if (path === '/layoutmeja') setCurrentView('layoutMeja');
    else if (path === '/profilekasir') setCurrentView('profile');
  }, [location.pathname]);

  const handleLogout = () => {
    dispatch(reset());
    dispatch(Logout());
    navigate('/');
  };

  const searchCustomers = async (term) => {
    try {
      const data = await fetchCustomers(term);
      setCustomers(data);
    } catch {
      // ignore
    }
  };

  const clearSelectedCustomer = () => {
    setSelectedCustomer(null);
    ignoreNextCustomerFocusRef.current = true;
    customerSearchInputRef.current?.blur?.();
    setTimeout(() => {
      ignoreNextCustomerFocusRef.current = false;
    }, 250);
  };

  const createNewCustomer = async () => {
    try {
      const created = await createCustomer(newCustomer);
      if (created) {
        setCustomers((prev) => [created, ...prev]);
        setSelectedCustomer(created);
        setShowCreateCustomerDialog(false);
        setNotification({ open: true, message: 'Customer baru berhasil ditambahkan', severity: 'success' });
      }
    } catch (e) {
      setNotification({
        open: true,
        message: e?.response?.data?.message || 'Gagal menambahkan customer',
        severity: 'error',
      });
    }
  };

  const handlePayClick = () => {
    if (orders.length === 0) {
      setNotification({ open: true, message: 'Keranjang kosong!', severity: 'warning' });
      return;
    }
    // Validasi meja untuk dine-in
    if (metode_pesanan === 'dinein' && !selectedTableId) {
      setNotification({ open: true, message: 'Silakan pilih meja untuk pesanan dine-in!', severity: 'error' });
      return;
    }
    // Take Away: metode wajib dipilih (bila cabang punya daftar metode Take Away).
    if (metode_pesanan === 'takeaway' && takeawayList.length > 0 && !selectedTakeawayName) {
      setNotification({ open: true, message: 'Silakan pilih metode Take Away!', severity: 'error' });
      return;
    }
    // Shift kasir wajib dibuka sebelum menerima pembayaran.
    if (adalahKasir && !shiftHook.shift) {
      setMintaShift(true);
      return;
    }
    // Shift terbuka lebih dari 24 jam (lupa ditutup): tutup dulu, hitung uang di laci.
    if (adalahKasir && shiftHook.terkunci) {
      setMintaTutupShift(true);
      return;
    }
    // Buka payment dialog
    setPaymentDialogOpen(true);
    setCustomerCash('');
    setBagi(bagiAwal());
    setDp(dpAwal());
    setReservasiBayar(reservasiBayarAwal());
    muatReservasiDp({ pilihUntukMeja: metode_pesanan === 'dinein' ? selectedTableId : null });
  };

  // Reservasi hari ini yang DP-nya sudah diterima (paket tanpa fitur Reservasi / bukan cafe: daftar kosong, tombolnya tidak tampil).
  // pilihUntukMeja: id meja yang dipilih kasir; bila meja itu punya reservasi ber-DP, reservasinya langsung terpilih (tetap bisa diganti).
  const muatReservasiDp = async ({ pilihUntukMeja = null } = {}) => {
    try {
      const r = await axios.get(`${getApiBaseUrl()}/reservasi`, { params: { status: 'aktif' }, withCredentials: true });
      setReservasiDpList(reservasiBerdp(r.data?.data));
      setReservasiAktif(r.data?.data || []);
      const cocok = reservasiUntukMeja(r.data?.data, pilihUntukMeja);
      if (cocok) {
        setReservasiBayar({ ...reservasiBayarAwal(), uuid: cocok.uuid });
        setSelectedPaymentMethod('reservasi');
      }
    } catch (e) {
      setReservasiDpList([]);
      setReservasiAktif([]);
    }
  };

  // Tanda reservasi di pilihan meja: dimuat saat kasir dibuka lalu diperbarui tiap menit (jam berjalan, status tamu berubah).
  useEffect(() => {
    muatReservasiDp();
    const t = setInterval(() => muatReservasiDp(), 60000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Mengubah pilihan di panel Reservasi saat QRIS sisa tagihan masih menunggu bayar: QRIS itu harus dibatalkan dulu (DP ditahan olehnya).
  const ubahReservasiBayar = async (baru) => {
    if (qrisUuidRef.current && (baru.metode !== reservasiBayar.metode || baru.uuid !== reservasiBayar.uuid)) {
      if (!(await batalkanQrisAktif())) return;
    }
    setReservasiBayar(baru);
  };

  // Pembayaran dengan DP reservasi: DP dipotong, sisa tunai / non-tunai / QRIS. Server mencatat DP sebagai bagian non-tunai "DP Reservasi <kode>".
  const processReservasiPayment = async () => {
    const h = hitungReservasiBayar(total, reservasiBayar, reservasiDpList, nonCashMethods);
    if (!h.sah) {
      setNotification({ open: true, message: h.galat || 'Lengkapi pembayaran dengan DP reservasi', severity: 'error' });
      return;
    }
    if (h.payload.pembayaran === 'qris') {
      await processQrisPayment({ reservasiUuid: h.r.uuid, baris: h.baris, kode: h.r.kode, nama: h.r.nama, customerUuid: h.r.customerUuid || null });
      return;
    }
    try {
      setPaymentStatus('loading');
      const resp = await axios.post(
        `${getApiBaseUrl()}/createtransaksicabang`,
        {
          ...h.payload,
          items: orders.map((order) => ({
            baranguuid: order.baranguuid,
            jumlahbarang: order.quantity,
            catatan: order.catatan || null,
            optionUuids: (order.selectedOptions || []).map((o) => o.optionUuid),
          })),
          // Pelanggan yang dipilih di keranjang didahulukan; bila kosong, atas nama pemesan reservasi (dan pelanggan terdaftarnya).
          namaCustomer: selectedCustomer ? selectedCustomer.nama : h.r.nama,
          customerUuid: selectedCustomer ? selectedCustomer.uuid : (h.r.customerUuid || null),
          ...(kodeKupon ? { kodeKupon } : {}),
          noted: noted || null,
          metode_pesanan: metode_pesanan || null,
          tableId: selectedTableId || null,
          takeawayName: metode_pesanan === 'takeaway' ? selectedTakeawayName : null,
        },
        { withCredentials: true }
      );

      const receiptPayload = {
        items: orders.map((order) => ({
          id: order.id,
          baranguuid: order.baranguuid,
          name: order.name,
          price: order.price,
          quantity: order.quantity,
          catatan: order.catatan || '',
          selectedOptions: order.selectedOptions || [],
        })),
        total,
        subtotal: discountedSubtotal,
        diskon: diskonPromo,
        promoNama,
        ppnPersen: ppnPersenValue,
        ppnNominal,
        paymentMethod: 'Split',
        paymentLines: h.baris,
        nomorAntrian: labelAntrian(resp.data?.data?.transaksi),
        namaCustomer: selectedCustomer ? selectedCustomer.nama : h.r.nama,
        noted: noted || '',
        customerCash: h.uangDiterima,
        change: h.kembalian,
        createdAt: new Date().toISOString(),
        orderId: resp.data?.data?.transaksi?.order_id,
        meja: labelMejaStruk(),
      };

      setNotification({
        open: true,
        message: `Pembayaran dengan DP reservasi ${h.r.kode} berhasil!${h.kembalian > 0 ? ` Kembalian: Rp ${formatCurrency(h.kembalian)}` : ''}${h.sisaDpKembali > 0 ? ` Kembalikan sisa DP Rp ${formatCurrency(h.sisaDpKembali)}.` : ''}`,
        severity: h.sisaDpKembali > 0 ? 'warning' : 'success',
      });
      decrementLocalStock(orders);
      setReceiptPreviewData(receiptPayload);
      setReceiptPreviewOpen(true);
      setOrders([]);
      setSelectedTableId(null);
      setSelectedTakeawayName(null);
      setSelectedCustomer(null);
      setPaymentDialogOpen(false);
      setCustomerCash('');
      setReservasiBayar(reservasiBayarAwal());
      setReservasiDpList([]);
      setSelectedPaymentMethod('cash');
      setQrCodeUrl('');
      setOrderId('');
      setPaymentStatus('idle');
      if (isMobile) setMobileCartOpen(false);
    } catch (error) {
      setNotification({
        open: true,
        message: error?.response?.data?.message || error?.message || 'Gagal memproses pembayaran!',
        severity: 'error',
      });
      setPaymentStatus('idle');
    }
  };

  const processCashPayment = async () => {
    const parsedCash = parseFloat(customerCash || 0);
    if (!customerCash || parsedCash < total) {
      setNotification({
        open: true,
        message: `Uang customer tidak cukup! Minimal Rp ${formatCurrency(total)}`,
        severity: 'error',
      });
      return;
    }

    try {
      setPaymentStatus('loading');
      const respCash = await axios.post(
        `${getApiBaseUrl()}/createtransaksicabang`,
        {
          pembayaran: 'cash',
          items: orders.map((order) => ({
            baranguuid: order.baranguuid,
            jumlahbarang: order.quantity,
            catatan: order.catatan || null,
            optionUuids: (order.selectedOptions || []).map((o) => o.optionUuid),
          })),
          namaCustomer: selectedCustomer ? selectedCustomer.nama : null,
          customerUuid: selectedCustomer ? selectedCustomer.uuid : null,
          ...(kodeKupon ? { kodeKupon } : {}),
          noted: noted || null,
          metode_pesanan: metode_pesanan || null,
          tableId: selectedTableId || null,
          takeawayName: metode_pesanan === 'takeaway' ? selectedTakeawayName : null,
          uangCustomer: parsedCash,
        },
        { withCredentials: true }
      );

      const receiptPayload = {
        items: orders.map((order) => ({
          id: order.id,
          baranguuid: order.baranguuid,
          name: order.name,
          price: order.price,
          quantity: order.quantity,
          catatan: order.catatan || '',
          selectedOptions: order.selectedOptions || [],
        })),
        total,
        subtotal: discountedSubtotal,
        diskon: diskonPromo,
        promoNama,
        ppnPersen: ppnPersenValue,
        ppnNominal,
        paymentMethod: 'Cash',
        nomorAntrian: labelAntrian(respCash.data?.data?.transaksi),
        namaCustomer: selectedCustomer ? selectedCustomer.nama : 'Walk-in Customer',
        noted: noted || '',
        customerCash: parsedCash,
        change: Math.max(0, parsedCash - total),
        createdAt: new Date().toISOString(),
        orderId: respCash.data?.data?.transaksi?.order_id,
        meja: labelMejaStruk(),
      };

      setNotification({
        open: true,
        message: `Pembayaran cash berhasil! Kembalian: Rp ${formatCurrency(parsedCash - total)}`,
        severity: 'success',
      });
      decrementLocalStock(orders);
      setReceiptPreviewData(receiptPayload);
      setReceiptPreviewOpen(true);
      setOrders([]);
      setSelectedTableId(null);
      setSelectedTakeawayName(null);
      setSelectedCustomer(null);
      setPaymentDialogOpen(false);
      setCustomerCash('');
      setQrCodeUrl('');
      setOrderId('');
      setPaymentStatus('idle');
      if (isMobile) setMobileCartOpen(false);
    } catch (error) {
      setNotification({
        open: true,
        message: error?.response?.data?.message || error?.message || 'Gagal memproses pembayaran!',
        severity: 'error',
      });
      setPaymentStatus('idle');
    }
  };

  const mulaiPollingQris = (currentOrderId) => {
    if (paymentPollingRef.current) {
      clearInterval(paymentPollingRef.current);
    }

    let pollCount = 0;
    paymentPollingRef.current = setInterval(async () => {
      pollCount += 1;
      try {
        const statusResponse = await axios.get(
          `${getApiBaseUrl()}/gettransaksinotification/${currentOrderId}`,
          { withCredentials: true }
        );
        const status = statusResponse.data?.data?.transaksi?.status_pembayaran;

        if (status === 'settlement') {
          clearInterval(paymentPollingRef.current);
          paymentPollingRef.current = null;
          qrisUuidRef.current = null;

          const receiptPayload = {
            items: orders.map((order) => ({
              id: order.id,
              baranguuid: order.baranguuid,
              name: order.name,
              price: order.price,
              quantity: order.quantity,
              catatan: order.catatan || '',
              selectedOptions: order.selectedOptions || [],
            })),
            total,
            subtotal: discountedSubtotal,
            diskon: diskonPromo,
            promoNama,
            ppnPersen: ppnPersenValue,
            ppnNominal,
            paymentMethod: reservasiQrisRef.current ? 'Split' : 'Qris',
            ...(reservasiQrisRef.current ? { paymentLines: reservasiQrisRef.current.baris } : {}),
            nomorAntrian: antrianQrisRef.current,
            namaCustomer: selectedCustomer ? selectedCustomer.nama : (reservasiQrisRef.current?.nama || 'Walk-in Customer'),
            noted: noted || '',
            customerCash: 0,
            change: 0,
            createdAt: new Date().toISOString(),
      orderId: currentOrderId,
      meja: labelMejaStruk(),
          };
          setNotification({ open: true, message: reservasiQrisRef.current ? `Pembayaran QRIS dengan DP reservasi ${reservasiQrisRef.current.kode} berhasil!` : 'Pembayaran QRIS berhasil!', severity: 'success' });
          if (reservasiQrisRef.current) {
            reservasiQrisRef.current = null;
            setReservasiBayar(reservasiBayarAwal());
            setReservasiDpList([]);
            setSelectedPaymentMethod('cash');
          }
          decrementLocalStock(orders);
          setReceiptPreviewData(receiptPayload);
          setReceiptPreviewOpen(true);
          setOrders([]);
          setSelectedTableId(null);
    setSelectedTakeawayName(null);
          setSelectedCustomer(null);
          setPaymentDialogOpen(false);
          setCustomerCash('');
          setQrCodeUrl('');
          setOrderId('');
          setPaymentStatus('idle');
          if (isMobile) setMobileCartOpen(false);
          return;
        }

        if (['cancel', 'cancelled', 'expire', 'failure'].includes(status)) {
          clearInterval(paymentPollingRef.current);
          paymentPollingRef.current = null;
          qrisUuidRef.current = null;
          setPaymentStatus('idle');
          setNotification({
            open: true,
            message: 'Pembayaran QRIS gagal atau dibatalkan. Silakan ulangi.',
            severity: 'error',
          });
        }
      } catch (error) {
        if (pollCount > 3) {
          setNotification({
            open: true,
            message: 'Gagal memeriksa status pembayaran QRIS. Coba lagi beberapa saat.',
            severity: 'error',
          });
        }
      }

      if (pollCount >= 60) {
        clearInterval(paymentPollingRef.current);
        paymentPollingRef.current = null;
        setPaymentStatus('idle');
        // Tidak dibayar dalam 3 menit: transaksi QRIS dibatalkan otomatis supaya tidak tertinggal menunggu bayar.
        batalkanQrisBelumBayar(getApiBaseUrl(), qrisUuidRef.current).then(({ hasil }) => {
          if (hasil === 'dibatalkan') {
            qrisUuidRef.current = null;
            setQrCodeUrl('');
            setOrderId('');
            setNotification({ open: true, message: 'QRIS tidak dibayar dan dibatalkan. Pesanan masih di keranjang; pilih metode pembayaran lagi.', severity: 'warning' });
          } else if (hasil === 'dibayar') {
            setPaymentStatus('qris_pending');
            mulaiPollingQris(currentOrderId);
          } else {
            setNotification({ open: true, message: 'Pembayaran QRIS timeout. Tutup dialog ini untuk membatalkannya.', severity: 'error' });
          }
        });
      }
    }, 3000);
  };

  // Membatalkan QRIS yang sudah tampil tetapi belum dibayar (kasir menutup dialog / pindah metode). true = tidak ada QRIS tertinggal lagi.
  const batalkanQrisAktif = async () => {
    if (!qrisUuidRef.current) return true;
    if (!(await konfirmasi(PESAN_BATAL_QRIS, { tombolYa: 'Batalkan QRIS', bahaya: true }))) return false;
    const uuid = qrisUuidRef.current;
    if (!uuid) return false; // sudah lunas selagi pertanyaan tampil
    const { hasil, pesan } = await batalkanQrisBelumBayar(getApiBaseUrl(), uuid);
    if (hasil === 'gagal') {
      setNotification({ open: true, message: pesan, severity: 'error' });
      return false;
    }
    if (hasil === 'dibayar') {
      setNotification({ open: true, message: 'QRIS ternyata sudah dibayar pelanggan. Menyelesaikan transaksi…', severity: 'info' });
      if (!paymentPollingRef.current) {
        setPaymentStatus('qris_pending');
        mulaiPollingQris(orderId);
      }
      return false;
    }
    if (paymentPollingRef.current) clearInterval(paymentPollingRef.current);
    paymentPollingRef.current = null;
    qrisUuidRef.current = null;
    setQrCodeUrl('');
    setOrderId('');
    setPaymentStatus('idle');
    setNotification({ open: true, message: 'QRIS dibatalkan. Pesanan masih di keranjang.', severity: 'info' });
    return true;
  };

  const tutupDialogBayar = async () => {
    if (paymentStatus === 'loading') return;
    if (await batalkanQrisAktif()) setPaymentDialogOpen(false);
  };

  // ekstra: data tambahan untuk transaksi QRIS, mis. { reservasiUuid } (DP reservasi + sisa QRIS), dan opsi { baris } untuk struk.
  const processQrisPayment = async (ekstra = null) => {
    if (ekstra && typeof ekstra.preventDefault === 'function') ekstra = null; // dipanggil sebagai onClick biasa
    if (total <= 0) {
      setNotification({ open: true, message: 'Keranjang kosong!', severity: 'warning' });
      return;
    }

    // Sisa QRIS sebelumnya yang belum dibatalkan (mis. pembatalan gagal): bereskan dulu supaya tidak ada transaksi ganda.
    if (qrisUuidRef.current && !(await batalkanQrisAktif())) return;

    try {
      setPaymentStatus('loading');
      const response = await axios.post(
        `${getApiBaseUrl()}/createtransaksicabang`,
        {
          pembayaran: 'qris',
          ...(ekstra?.reservasiUuid ? { reservasiUuid: ekstra.reservasiUuid } : {}),
          items: orders.map((order) => ({
            baranguuid: order.baranguuid,
            jumlahbarang: order.quantity,
            catatan: order.catatan || null,
            optionUuids: (order.selectedOptions || []).map((o) => o.optionUuid),
          })),
          namaCustomer: selectedCustomer ? selectedCustomer.nama : (ekstra?.nama || null),
          customerUuid: selectedCustomer ? selectedCustomer.uuid : (ekstra?.customerUuid || null),
          ...(kodeKupon ? { kodeKupon } : {}),
          noted: noted || null,
          metode_pesanan: metode_pesanan || null,
          tableId: selectedTableId || null,
          takeawayName: metode_pesanan === 'takeaway' ? selectedTakeawayName : null,
        },
        { withCredentials: true }
      );
      // Struk transaksi QRIS dengan DP reservasi memuat rincian DP + QRIS (dipakai saat lunas di mulaiPollingQris).
      reservasiQrisRef.current = ekstra?.reservasiUuid ? { baris: ekstra.baris || [], kode: ekstra.kode || '', nama: ekstra.nama || '' } : null;

      const qrisData = response.data?.data?.qris_data;
      const transaksi = response.data?.data?.transaksi;
      antrianQrisRef.current = labelAntrian(transaksi);
      const generatedImageUrl = qrisData?.generated_image_url;
      const currentOrderId = transaksi?.order_id;

      if ((!generatedImageUrl && !qrisData?.qr_string) || !currentOrderId) {
        setPaymentStatus('idle');
        setNotification({ open: true, message: 'Data QRIS tidak lengkap dari payment gateway.', severity: 'error' });
        return;
      }

      // qrCodeUrl berisi data QRIS (gambar Sandbox / qr_string / mode), ditampilkan lewat QrisKasir.
      setQrCodeUrl({ url: generatedImageUrl, qrString: qrisData?.qr_string, isProduction: !!qrisData?.isProduction });
      setOrderId(currentOrderId);
      qrisUuidRef.current = transaksi?.uuid || null;
      setPaymentStatus('qris_pending');
      mulaiPollingQris(currentOrderId);
    } catch (error) {
      setPaymentStatus('idle');
      setNotification({
        open: true,
        message:
          error?.response?.data?.message ||
          error?.response?.data?.msg ||
          error?.message ||
          'Payment gateway QRIS gagal diproses.',
        severity: 'error',
      });
    }
  };

  const processNonCashPayment = async () => {
    const selectedMethod = nonCashMethods.find((m) => m.uuid === selectedNonCashMethodUuid);
    if (!selectedMethod) {
      setNotification({ open: true, message: 'Pilih metode non cash terlebih dahulu!', severity: 'error' });
      return;
    }

    try {
      setPaymentStatus('loading');
      const respNon = await axios.post(
        `${getApiBaseUrl()}/createtransaksicabang`,
        {
          pembayaran: 'noncash',
          nonCashMethodName: selectedMethod.name,
          items: orders.map((order) => ({
            baranguuid: order.baranguuid,
            jumlahbarang: order.quantity,
            catatan: order.catatan || null,
            optionUuids: (order.selectedOptions || []).map((o) => o.optionUuid),
          })),
          namaCustomer: selectedCustomer ? selectedCustomer.nama : null,
          customerUuid: selectedCustomer ? selectedCustomer.uuid : null,
          ...(kodeKupon ? { kodeKupon } : {}),
          noted: noted || null,
          metode_pesanan: metode_pesanan || null,
          tableId: selectedTableId || null,
          takeawayName: metode_pesanan === 'takeaway' ? selectedTakeawayName : null,
        },
        { withCredentials: true }
      );

      const receiptPayload = {
        items: orders.map((order) => ({
          id: order.id,
          baranguuid: order.baranguuid,
          name: order.name,
          price: order.price,
          quantity: order.quantity,
          catatan: order.catatan || '',
          selectedOptions: order.selectedOptions || [],
        })),
        total,
        subtotal: discountedSubtotal,
        diskon: diskonPromo,
        promoNama,
        ppnPersen: ppnPersenValue,
        ppnNominal,
        paymentMethod: 'Non Cash',
        nomorAntrian: labelAntrian(respNon.data?.data?.transaksi),
        namaCustomer: selectedCustomer ? selectedCustomer.nama : 'Walk-in Customer',
        noted: noted || '',
        customerCash: 0,
        change: 0,
        createdAt: new Date().toISOString(),
        orderId: respNon.data?.data?.transaksi?.order_id,
        meja: labelMejaStruk(),
      };

      setNotification({
        open: true,
        message: 'Pembayaran non cash berhasil!',
        severity: 'success',
      });
      decrementLocalStock(orders);
      setReceiptPreviewData(receiptPayload);
      setReceiptPreviewOpen(true);
      setOrders([]);
      setSelectedTableId(null);
      setSelectedTakeawayName(null);
      setSelectedCustomer(null);
      setPaymentDialogOpen(false);
      setCustomerCash('');
      setSelectedNonCashMethodUuid('');
      setQrCodeUrl('');
      setOrderId('');
      setPaymentStatus('idle');
      if (isMobile) setMobileCartOpen(false);
    } catch (error) {
      setNotification({
        open: true,
        message: error?.response?.data?.message || error?.message || 'Gagal memproses pembayaran!',
        severity: 'error',
      });
      setPaymentStatus('idle');
    }
  };

  // Pembayaran bagi: tunai + non-tunai (atau beberapa non-tunai). Server memeriksa ulang terhadap total yang dihitungnya.
  const processBagiPayment = async () => {
    const hasil = hitungBagi(total, bagi, nonCashMethods);
    if (hasil.galat) {
      setNotification({ open: true, message: hasil.galat, severity: 'error' });
      return;
    }

    try {
      setPaymentStatus('loading');
      const respBagi = await axios.post(
        `${getApiBaseUrl()}/createtransaksicabang`,
        {
          pembayaranBagi: hasil.payload,
          items: orders.map((order) => ({
            baranguuid: order.baranguuid,
            jumlahbarang: order.quantity,
            catatan: order.catatan || null,
            optionUuids: (order.selectedOptions || []).map((o) => o.optionUuid),
          })),
          namaCustomer: selectedCustomer ? selectedCustomer.nama : null,
          customerUuid: selectedCustomer ? selectedCustomer.uuid : null,
          ...(kodeKupon ? { kodeKupon } : {}),
          noted: noted || null,
          metode_pesanan: metode_pesanan || null,
          tableId: selectedTableId || null,
          takeawayName: metode_pesanan === 'takeaway' ? selectedTakeawayName : null,
          uangCustomer: hasil.tunaiDiterima,
        },
        { withCredentials: true }
      );

      const receiptPayload = {
        items: orders.map((order) => ({
          id: order.id,
          baranguuid: order.baranguuid,
          name: order.name,
          price: order.price,
          quantity: order.quantity,
          catatan: order.catatan || '',
          selectedOptions: order.selectedOptions || [],
        })),
        total,
        subtotal: discountedSubtotal,
        diskon: diskonPromo,
        promoNama,
        ppnPersen: ppnPersenValue,
        ppnNominal,
        paymentMethod: 'Split',
        nomorAntrian: labelAntrian(respBagi.data?.data?.transaksi),
        paymentLines: hasil.baris,
        namaCustomer: selectedCustomer ? selectedCustomer.nama : 'Walk-in Customer',
        noted: noted || '',
        customerCash: hasil.tunaiDiterima,
        change: hasil.kembalian,
        createdAt: new Date().toISOString(),
        orderId: respBagi.data?.data?.transaksi?.order_id,
        meja: labelMejaStruk(),
      };

      setNotification({
        open: true,
        message: hasil.kembalian > 0 ? `Pembayaran bagi berhasil! Kembalian: Rp ${formatCurrency(hasil.kembalian)}` : 'Pembayaran bagi berhasil!',
        severity: 'success',
      });
      decrementLocalStock(orders);
      setReceiptPreviewData(receiptPayload);
      setReceiptPreviewOpen(true);
      setOrders([]);
      setSelectedTableId(null);
      setSelectedTakeawayName(null);
      setSelectedCustomer(null);
      setPaymentDialogOpen(false);
      setCustomerCash('');
      setBagi(bagiAwal());
      setSelectedNonCashMethodUuid('');
      setQrCodeUrl('');
      setOrderId('');
      setPaymentStatus('idle');
      if (isMobile) setMobileCartOpen(false);
    } catch (error) {
      setNotification({
        open: true,
        message: error?.response?.data?.message || error?.message || 'Gagal memproses pembayaran bagi!',
        severity: 'error',
      });
      setPaymentStatus('idle');
    }
  };

  // Uang muka (DP): sebagian dibayar sekarang, sisanya jadi piutang pelanggan. Server memeriksa ulang terhadap total yang dihitungnya.
  const processDpPayment = async () => {
    const hasil = hitungDp(total, dp, nonCashMethods);
    if (hasil.galat) {
      setNotification({ open: true, message: hasil.galat, severity: 'error' });
      return;
    }

    try {
      setPaymentStatus('loading');
      const respDp = await axios.post(
        `${getApiBaseUrl()}/createtransaksicabang`,
        {
          pembayaran: 'cash',
          dp: hasil.payload,
          items: orders.map((order) => ({
            baranguuid: order.baranguuid,
            jumlahbarang: order.quantity,
            catatan: order.catatan || null,
            optionUuids: (order.selectedOptions || []).map((o) => o.optionUuid),
          })),
          namaCustomer: dp.pelanggan.nama,
          customerUuid: dp.pelanggan.uuid,
          ...(kodeKupon ? { kodeKupon } : {}),
          noted: noted || null,
          metode_pesanan: metode_pesanan || null,
          tableId: selectedTableId || null,
          takeawayName: metode_pesanan === 'takeaway' ? selectedTakeawayName : null,
        },
        { withCredentials: true }
      );

      const receiptPayload = {
        items: orders.map((order) => ({
          id: order.id,
          baranguuid: order.baranguuid,
          name: order.name,
          price: order.price,
          quantity: order.quantity,
          catatan: order.catatan || '',
          selectedOptions: order.selectedOptions || [],
        })),
        total,
        subtotal: discountedSubtotal,
        diskon: diskonPromo,
        promoNama,
        ppnPersen: ppnPersenValue,
        ppnNominal,
        paymentMethod: 'DP',
        nomorAntrian: labelAntrian(respDp.data?.data?.transaksi),
        paymentLines: hasil.baris,
        namaCustomer: dp.pelanggan.nama,
        noted: noted || '',
        customerCash: hasil.dibayar,
        change: 0,
        createdAt: new Date().toISOString(),
        orderId: respDp.data?.data?.transaksi?.order_id,
        meja: labelMejaStruk(),
      };

      setNotification({
        open: true,
        message: `Uang muka tercatat. Sisa tagihan Rp ${formatCurrency(hasil.sisa)} masuk piutang ${dp.pelanggan.nama}`,
        severity: 'success',
      });
      decrementLocalStock(orders);
      setReceiptPreviewData(receiptPayload);
      setReceiptPreviewOpen(true);
      setOrders([]);
      setSelectedTableId(null);
      setSelectedTakeawayName(null);
      setSelectedCustomer(null);
      setPaymentDialogOpen(false);
      setCustomerCash('');
      setDp(dpAwal());
      setSelectedNonCashMethodUuid('');
      setQrCodeUrl('');
      setOrderId('');
      setPaymentStatus('idle');
      if (isMobile) setMobileCartOpen(false);
    } catch (error) {
      setNotification({
        open: true,
        message: error?.response?.data?.message || error?.message || 'Gagal memproses uang muka!',
        severity: 'error',
      });
      setPaymentStatus('idle');
    }
  };

  const handleSaveClick = () => {
    handlePayClick();
  };

  // Satu aturan tata letak (struk/strukLayout.js) untuk pratinjau, cetak browser, dan Bluetooth: sama dengan struk Flutter.
  const barisUntuk = (receipt) =>
    barisStrukKasir({
      receipt,
      cabangConfig,
      namaCabang: branchName || 'Kasir',
      kasir: user?.nama || 'Kasir',
      logoUrl: receiptLogoUrl,
    });

  const printBrowserReceipt = (receipt) => {
    if (!receipt?.items?.length) {
      setNotification({ open: true, message: 'Tidak ada data nota untuk dicetak', severity: 'error' });
      return;
    }
    cetakBrowser(barisUntuk(receipt));
  };

  // laci: true hanya untuk cetak otomatis setelah pembayaran (bukan tombol cetak ulang): laci terbuka bila diatur otomatis & ada uang tunai.
  const printReceipt = async (receipt, { laci = false } = {}) => {
    if (!receipt) return;
    if (!printerConnected || !printerInstance) {
      printBrowserReceipt(receipt);
      return;
    }
    try {
      setIsPrinting(true);
      const bukaLaci = laci && harusBukaLaciOtomatis(cabangConfig, receipt);
      await printerInstance.printBaris(barisUntuk(receipt), undefined, { laci: bukaLaci ? { pin: bacaLaci(cabangConfig).pin } : null });
      setNotification({ open: true, message: 'Nota berhasil dicetak via Bluetooth.', severity: 'success' });
    } catch (error) {
      setNotification({ open: true, message: error?.message || 'Gagal cetak Bluetooth, fallback browser.', severity: 'warning' });
      printBrowserReceipt(receipt);
    } finally {
      setIsPrinting(false);
    }
  };

  useEffect(() => {
    return () => {
      if (paymentPollingRef.current) {
        clearInterval(paymentPollingRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (receiptPreviewOpen && receiptPreviewData && printerConnected && printerInstance) {
      printReceipt(receiptPreviewData, { laci: true });
    }
  }, [receiptPreviewOpen, receiptPreviewData, printerConnected, printerInstance]);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: POS_BG,
        }}
      >
        <Typography sx={{ color: '#6b778c', fontWeight: 700 }}>Memuat…</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">Gagal memuat data produk.</Alert>
      </Box>
    );
  }
const LEFT_SIDEBAR_W = 280; // sesuai sidebar LayoutKasir
const TOP_APPBAR_H = 64;
  return (
    <Box sx={{ backgroundColor: POS_BG, minHeight: '100vh', pb: isMobile ? 8 : 0 }}>
      {/* Thermal Printer */}
      {showPrinterSettings && (
        <ThermalPrinter
          open={showPrinterSettings}
          onClose={() => setShowPrinterSettings(false)}
          onPrinterConnected={(device) => {
            setPrinterInstance(device);
            setPrinterConnected(true);
            setNotification({ open: true, message: 'Printer berhasil terhubung!', severity: 'success' });
          }}
          onPrinterDisconnected={() => {
            setPrinterInstance(null);
            setPrinterConnected(false);
            setNotification({ open: true, message: 'Printer terputus', severity: 'info' });
          }}
          currentPrinter={printerInstance}
          connectionStatus={printerInstance?.getConnectionStatus?.()}
        />
      )}

      {/* Bottom Navigation — mobile */}
      {isMobile && (
        <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
          <BottomNavigation
            value={currentView}
            onChange={(_, newValue) => {
              if (newValue === 'logout') handleLogout();
              else if (newValue === 'home') navigate('/produkpercabang');
              else if (newValue === 'history') navigate('/transaksikasir');
              else if (newValue === 'notification') navigate('/notification-kasir');
              else if (newValue === 'profile') navigate('/profilekasir');
            }}
            showLabels
          >
            <BottomNavigationAction label="Home" value="home" icon={<HomeOutlined />} />
            <BottomNavigationAction label="Transaksi" value="history" icon={<ReceiptOutlined />} />
            <BottomNavigationAction label="Notifikasi" value="notification" icon={<NotificationsIcon />} />
            <BottomNavigationAction label="Profile" value="profile" icon={<PersonOutlined />} />
          </BottomNavigation>
        </Paper>
      )}

     <AppBar
  position="fixed"
  elevation={0}
  sx={{
    backgroundColor: 'white',
    borderBottom: `1px solid ${POS_BORDER}`,
    top: TOP_APPBAR_H,
    left: !isMobile ? LEFT_SIDEBAR_W : 0,
    width: !isMobile
      ? `calc(100% - ${LEFT_SIDEBAR_W}px - ${RIGHT_DRAWER_W}px)`
      : '100%',
    transition: 'width 0.25s ease, left 0.25s ease',
    zIndex: 1200,
  }}
>
        <Toolbar
          sx={{
            gap: 1.5,
            py: 1.25,
            flexWrap: isMobile ? 'wrap' : 'nowrap',
            alignItems: 'center',
          }}
        >
          {isMobile && (
            <Typography variant="subtitle1" fontWeight={900} sx={{ color: '#172b4d', mr: 'auto' }}>
              {branchName}
            </Typography>
          )}

          <TextField
            inputRef={productSearchInputRef}
            placeholder="Cari menu, kode, atau scan barcode…"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            size="small"
            sx={{
              flex: isMobile ? '1 1 100%' : 1,
              minWidth: isMobile ? '100%' : 280,
              maxWidth: isMobile ? '100%' : 720,
              order: isMobile ? 3 : 0,
              '& .MuiOutlinedInput-root': {
                borderRadius: 2.25,
                backgroundColor: '#f4f5f7',
                '& fieldset': { border: 'none' },
                '&:hover fieldset': { border: 'none' },
                '&.Mui-focused fieldset': { border: `1px solid ${POS_PRIMARY}` },
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <MagnifyingGlass size={20} color="#97a0af" />
                </InputAdornment>
              ),
              endAdornment: !isMobile ? (
                <InputAdornment position="end">
                  <Chip
                    label="F1"
                    size="small"
                    sx={{ height: 22, fontSize: 11, fontWeight: 900, bgcolor: '#dfe1e6' }}
                  />
                </InputAdornment>
              ) : null,
            }}
          />

          <Tooltip title={printerConnected ? 'Printer terhubung' : 'Hubungkan printer'}>
            <IconButton
              onClick={() => setShowPrinterSettings(true)}
              sx={{ color: printerConnected ? '#16a34a' : '#97a0af' }}
            >
              <Badge variant="dot" color={printerConnected ? 'success' : 'error'} overlap="circular">
                <PrintOutlined />
              </Badge>
            </IconButton>
          </Tooltip>

          <TombolBukaLaci
            printer={printerInstance}
            konfigurasi={cabangConfig}
            onPesan={(severity, message) => setNotification({ open: true, message, severity })}
          />

          {isMobile && (
            <IconButton
              onClick={() => setMobileCartOpen(true)}
              disabled={orders.length === 0}
              sx={{ color: '#42526e' }}
            >
              <Badge badgeContent={orders.reduce((s, i) => s + i.quantity, 0)} color="error">
                <ShoppingCart size={22} />
              </Badge>
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      {/* Konten utama — margin kanan untuk cart drawer */}
      <Box
        sx={{
          mr: !isMobile ? `${RIGHT_DRAWER_W}px` : 0,
          transition: 'margin 0.25s ease',
          minHeight: '100vh',
          backgroundColor: 'white',
        }}
      >
        {/* ✅ pt sebagai offset tinggi AppBar agar tidak tertutup */}
        <Box sx={{ px: 2, py: 2, pt: isMobile ? 10 : 9 }}>

          {/* Toggle view mode */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'stretch' : 'center',
              justifyContent: 'space-between',
              mb: 1.5,
            }}
          >
            <Typography variant="h6" fontWeight={900} sx={{ color: '#172b4d', fontSize: '1rem' }} />
            <ToggleButtonGroup
              exclusive
              size="small"
              value={productViewMode}
              onChange={(_, v) => v && setProductViewMode(v)}
              sx={{
                '& .MuiToggleButton-root': {
                  px: 1,
                  py: 0.5,
                  border: `1px solid ${POS_BORDER}`,
                  fontSize: '0.875rem',
                  '&.Mui-selected': {
                    backgroundColor: POS_PRIMARY,
                    color: 'white',
                    borderColor: POS_PRIMARY,
                    '&:hover': { backgroundColor: POS_PRIMARY_HOVER },
                  },
                },
              }}
            >
              <ToggleButton value="grid" aria-label="tampilan grid">
                <ViewModuleOutlined sx={{ fontSize: 18 }} />
              </ToggleButton>
              <ToggleButton value="list" aria-label="tampilan daftar">
                <ViewListOutlined sx={{ fontSize: 18 }} />
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>

        {/* Shift kasir: buka / kas / tutup (wajib sebelum menerima pembayaran) */}
        {adalahKasir && <KartuShiftWeb
          shiftHook={shiftHook}
          mintaBuka={mintaShift}
          onMintaBukaSelesai={() => setMintaShift(false)}
          mintaTutup={mintaTutupShift}
          onMintaTutupSelesai={() => setMintaTutupShift(false)}
          namaKasir={user?.nama || user?.username}
          onPesan={(message) => setNotification({ open: true, message, severity: 'info' })}
        />}

        {/* Kategori - Dropdown */}
<Box sx={{ mb: 2 }}>
  <Select
    value={selectedCategory}
    onChange={(e) => setSelectedCategory(e.target.value)}
    displayEmpty
    size="small"
    sx={{
      minWidth: 200,
      borderRadius: 2,
      backgroundColor: '#f4f5f7',
      '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: `1px solid ${POS_PRIMARY}`,
      },
    }}
  >
    <MenuItem value="">Semua Kategori</MenuItem>
    {categories.map((category) => (
      <MenuItem key={category.uuid} value={category.namakategori}>
        {category.namakategori}
      </MenuItem>
    ))}
  </Select>
</Box>

          {/* Grid produk */}
            {/* <Grid container spacing={{ xs: 1, sm: 1, md: 1.25 }} columns={{ xs: 2, sm: 3, md: 4, lg: 5 }} sx={{ mb: 2 }}> */}
            <Grid container spacing={{ xs: 1, sm: 1, md: 1.25 }} columns={{ xs: 2, sm: 2, md: 3, lg: 4 }} sx={{ mb: 2 }}>
            <AnimatePresence>
              {filteredProducts.map((product, idx) => {
                const uniqueKey =
                  product.baranguuid ||
                  product.uuid ||
                  `product-${product.Barang?.namabarang || 'product'}-${idx}`;
                return (
                  <Grid
                    item
                    xs={productViewMode === 'list' ? 2 : 1}
                    sm={productViewMode === 'list' ? 3 : 1}
                    md={productViewMode === 'list' ? 4 : 1}
                    lg={productViewMode === 'list' ? 5 : 1}
                    key={uniqueKey}
                  >
                    <motion.div
                      initial={{ opacity: 0, scale: 0.95 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.95 }}
                      transition={{ duration: 0.2, delay: idx * 0.03 }}
                      style={{ height: '100%' }}
                    >
                      <CardProductPercabang
                        product={product}
                        viewMode={productViewMode}
                        onAdd={handleProductAdd}
                      />
                    </motion.div>
                  </Grid>
                );
              })}
            </AnimatePresence>
          </Grid>
        </Box>
      </Box>

      {/* Floating cart button — mobile */}
      {isMobile && orders.length > 0 && (
        <FloatingCartButton onClick={() => setMobileCartOpen(true)}>
          <Badge badgeContent={orders.reduce((s, i) => s + i.quantity, 0)} color="error">
            <ShoppingCart size={28} weight="fill" />
          </Badge>
        </FloatingCartButton>
      )}

      <ProductOptionsDialogKasir
        open={Boolean(optionsDialogProduct)}
        onClose={() => setOptionsDialogProduct(null)}
        product={optionsDialogProduct}
        onConfirm={(prod, options) => addToOrder(prod, options)}
      />

      {/* Cart drawer */}
      <CartProductPercabang
        isMobile={isMobile}
        noted={noted}
  setNoted={setNoted}
        openMobile={mobileCartOpen}
        setOpenMobile={setMobileCartOpen}
        products={products}
        orders={orders}
        subtotal={subtotal}
        total={total}
        ppnAktif={ppnAktif}
        ppnPersenValue={ppnPersenValue}
        ppnNominal={ppnNominal}
        updateOrderNote={updateOrderNote}
        diskonPromo={diskonPromo}
        promoNama={promoNama}
        metode_pesanan={metode_pesanan}
        setMetode_pesanan={setMetode_pesanan}
        selectedTableId={selectedTableId}
        setSelectedTableId={setSelectedTableId}
        tables={tables}
        reservasiMeja={reservasiMeja}
        takeawayList={takeawayList}
        selectedTakeawayName={selectedTakeawayName}
        setSelectedTakeawayName={setSelectedTakeawayName}
        onOpenCustomerDialog={() => setShowCustomerDialog(true)}
        customerSearchTerm={customerSearchTerm}
        setCustomerSearchTerm={setCustomerSearchTerm}
        searchCustomers={searchCustomers}
        ignoreNextCustomerFocusRef={ignoreNextCustomerFocusRef}
        customerSearchInputRef={customerSearchInputRef}
        selectedCustomer={selectedCustomer}
        clearSelectedCustomer={clearSelectedCustomer}
        selectedPaymentMethod={selectedPaymentMethod}
        setSelectedPaymentMethod={setSelectedPaymentMethod}
        onPayClick={handlePayClick}
        onSaveClick={handleSaveClick}
        incrementOrder={incrementOrder}
        decrementOrder={decrementOrder}
        removeOrder={removeOrder}
        formatCurrency={formatCurrency}
        notificationSetter={setNotification}
      />


      {/* Dialog pilih customer */}
      <Dialog
        open={showCustomerDialog}
        onClose={() => {
          ignoreNextCustomerFocusRef.current = true;
          setShowCustomerDialog(false);
          setCustomerSearchTerm('');
          customerSearchInputRef.current?.blur?.();
          setTimeout(() => {
            ignoreNextCustomerFocusRef.current = false;
          }, 250);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Pilih Customer</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            placeholder="Cari customer..."
            value={customerSearchTerm}
            onChange={(e) => {
              setCustomerSearchTerm(e.target.value);
              if (e.target.value.length >= 2) searchCustomers(e.target.value);
            }}
            sx={{ mb: 2 }}
          />
          <Box sx={{ maxHeight: 380, overflow: 'auto' }}>
            {customers.map((c) => (
              <Paper
                key={c.uuid}
                onClick={() => {
                  ignoreNextCustomerFocusRef.current = true;
                  setSelectedCustomer(c);
                  setShowCustomerDialog(false);
                  setCustomerSearchTerm('');
                  customerSearchInputRef.current?.blur?.();
                  setTimeout(() => {
                    ignoreNextCustomerFocusRef.current = false;
                  }, 250);
                }}
                sx={{
                  p: 1.5,
                  mb: 1,
                  border: `1px solid ${POS_BORDER}`,
                  borderRadius: 2,
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: '#f4f5f7' },
                }}
                elevation={0}
              >
                <Typography>{c.nama}</Typography>
                <Typography variant="caption" sx={{ color: '#6b778c' }}>
                  {c.telepon}
                </Typography>
              </Paper>
            ))}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowCreateCustomerDialog(true)}>+ Customer Baru</Button>
          <Button
            variant="contained"
            onClick={() => setShowCustomerDialog(false)}
            sx={{ bgcolor: POS_PRIMARY, '&:hover': { bgcolor: POS_PRIMARY_HOVER } }}
          >
            Tutup
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog buat customer baru */}
      <Dialog
        open={showCreateCustomerDialog}
        onClose={() => setShowCreateCustomerDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 900 }}>Tambah Customer Baru</DialogTitle>
        <DialogContent sx={{ pt: 1 }}>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nama *"
                value={newCustomer.nama}
                onChange={(e) => setNewCustomer((p) => ({ ...p, nama: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Nomor Telepon *"
                value={newCustomer.telepon}
                onChange={(e) => setNewCustomer((p) => ({ ...p, telepon: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                value={newCustomer.email}
                onChange={(e) => setNewCustomer((p) => ({ ...p, email: e.target.value }))}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Select
                fullWidth
                displayEmpty
                value={newCustomer.kategoriCustomerUuid}
                onChange={(e) =>
                  setNewCustomer((p) => ({ ...p, kategoriCustomerUuid: e.target.value }))
                }
                sx={{ borderRadius: 2 }}
              >
                <MenuItem value="">
                  <em>Pilih kategori</em>
                </MenuItem>
                {customerCategories.map((cat) => (
                  <MenuItem key={cat.uuid} value={cat.uuid}>
                    {cat.namaKategoriCustomer}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Alamat"
                multiline
                rows={2}
                value={newCustomer.alamat}
                onChange={(e) => setNewCustomer((p) => ({ ...p, alamat: e.target.value }))}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button onClick={() => setShowCreateCustomerDialog(false)}>Batal</Button>
          <Button
            variant="contained"
            onClick={createNewCustomer}
            disabled={!newCustomer.nama || !newCustomer.telepon}
            sx={{ bgcolor: POS_PRIMARY, '&:hover': { bgcolor: POS_PRIMARY_HOVER } }}
          >
            Simpan
          </Button>
        </DialogActions>
      </Dialog>

      {/* Payment Dialog - Pembayaran Cash */}
      <Dialog
        open={paymentDialogOpen}
        onClose={tutupDialogBayar}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 900, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Pembayaran</Typography>
          <IconButton 
            onClick={tutupDialogBayar}
            disabled={paymentStatus === 'loading'}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Box sx={{ mb: 2.5 }}>
            {diskonPromo > 0 && (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="body2" sx={{ color: '#6b778c' }}>Sebelum promo</Typography>
                  <Typography variant="body2">{formatCurrency(subtotal)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 600 }}>Promo{promoNama ? `: ${promoNama}` : ''}</Typography>
                  <Typography variant="body2" sx={{ color: '#2e7d32', fontWeight: 600 }}>- {formatCurrency(diskonPromo)}</Typography>
                </Box>
              </>
            )}
            {ppnNominal > 0 && (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                  <Typography variant="body2" sx={{ color: '#6b778c' }}>Subtotal</Typography>
                  <Typography variant="body2">{formatCurrency(discountedSubtotal)}</Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                  <Typography variant="body2" sx={{ color: '#6b778c' }}>PPN {ppnPersenValue}%</Typography>
                  <Typography variant="body2">{formatCurrency(ppnNominal)}</Typography>
                </Box>
              </>
            )}
            <Typography variant="body2" sx={{ color: '#6b778c', mb: 0.5 }}>Total Pembayaran</Typography>
            <Typography variant="h4" sx={{ fontWeight: 900, color: POS_PRIMARY }}>
              {formatCurrency(total)}
            </Typography>
          </Box>

          <KuponPanel
            kodeTerpasang={kodeKupon} onPasang={setKodeKupon} kupon={promo.kupon} galat={promo.kuponGalat}
            disabled={['loading', 'qris_pending'].includes(paymentStatus)} sx={{ mb: 2 }}
          />

          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>Metode Pembayaran</Typography>
          <ToggleButtonGroup
            value={selectedPaymentMethod}
            exclusive
            onChange={async (e, value) => {
              if (!value) return;
              if (value !== 'qris' && qrisUuidRef.current && !(await batalkanQrisAktif())) return;
              setSelectedPaymentMethod(value);
              if (value !== 'noncash') setSelectedNonCashMethodUuid('');
              // Pelanggan yang sudah dipilih di keranjang ikut jadi pelanggan uang muka.
              if (value === 'dp' && !dp.pelanggan && selectedCustomer) setDp({ ...dp, pelanggan: selectedCustomer });
            }}
            fullWidth
            size="small"
            sx={{ mb: 2.5 }}
          >
            <ToggleButton value="cash" sx={{ py: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                Tunai
              </Box>
            </ToggleButton>
            {qrisEnabled && (
              <ToggleButton value="qris" sx={{ py: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  QRIS
                </Box>
              </ToggleButton>
            )}
            <ToggleButton value="noncash" sx={{ py: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                Non Cash
              </Box>
            </ToggleButton>
            <ToggleButton value="bagi" sx={{ py: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                Bagi
              </Box>
            </ToggleButton>
            <ToggleButton value="dp" sx={{ py: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                DP
              </Box>
            </ToggleButton>
            {reservasiDpList.length > 0 && (
              <ToggleButton value="reservasi" sx={{ py: 1 }} data-testid="metode-reservasi">
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  Reservasi
                </Box>
              </ToggleButton>
            )}
          </ToggleButtonGroup>

          {selectedPaymentMethod === 'reservasi' && (
            <ReservasiBayarPanel
              total={total}
              state={reservasiBayar}
              onChange={ubahReservasiBayar}
              daftar={reservasiDpList}
              nonCashMethods={nonCashMethods}
              disabled={['loading', 'qris_pending'].includes(paymentStatus)}
              qrisAktif={qrisEnabled}
              qris={reservasiBayar.metode === 'qris' ? qrCodeUrl : null}
              orderId={orderId}
              sx={{ mb: 2 }}
            />
          )}

          {selectedPaymentMethod === 'dp' && (
            <DpPanel
              total={total}
              nonCashMethods={nonCashMethods}
              state={dp}
              onChange={setDp}
              disabled={paymentStatus === 'loading'}
              sx={{ mb: 2 }}
            />
          )}

          {selectedPaymentMethod === 'bagi' && (
            <BagiBayarPanel
              total={total}
              nonCashMethods={nonCashMethods}
              state={bagi}
              onChange={setBagi}
              disabled={paymentStatus === 'loading'}
              sx={{ mb: 2 }}
            />
          )}

          {selectedPaymentMethod === 'cash' && (
            <Box sx={{ mb: 2 }}>
              <TextField
                fullWidth
                label="Uang Customer"
                type="number"
                placeholder="Masukkan jumlah uang"
                value={customerCash}
                onChange={(e) => setCustomerCash(e.target.value)}
                sx={{ mb: 1.5 }}
                disabled={paymentStatus === 'loading'}
                inputProps={{ step: '1000', min: '0' }}
              />
              {customerCash && (
                <Box sx={{ p: 1.25, bgcolor: '#f0f2f5', borderRadius: 1 }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.75 }}>
                    <Typography variant="body2">Total</Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600 }}>{formatCurrency(total)}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography variant="body2">Kembalian</Typography>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        fontWeight: 700, 
                        color: parseFloat(customerCash || 0) >= total ? '#16a34a' : '#dc2626' 
                      }}
                    >
                      {formatCurrency(Math.max(0, parseFloat(customerCash || 0) - total))}
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          )}

          {selectedPaymentMethod === 'qris' && (
            <Box sx={{ textAlign: 'center', py: 2 }}>
              <Typography variant="body2" sx={{ color: '#6b778c', mb: 1 }}>
                {qrCodeUrl ? 'Silakan scan QRIS berikut' : 'Klik Bayar untuk generate QRIS'}
              </Typography>
              {qrCodeUrl ? (
                <QrisKasir qris={qrCodeUrl} orderId={orderId} />
              ) : (
                <Box sx={{ width: 120, height: 120, mx: 'auto', bgcolor: '#e5e7eb', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <QrCode2Outlined sx={{ fontSize: 60, color: '#9ca3af' }} />
                </Box>
              )}
            </Box>
          )}

          {selectedPaymentMethod === 'noncash' && (
            <Box sx={{ mb: 2 }}>
              <TextField
                select
                fullWidth
                label="Pilih Metode"
                value={selectedNonCashMethodUuid}
                onChange={(e) => setSelectedNonCashMethodUuid(e.target.value)}
                disabled={paymentStatus === 'loading'}
                sx={{ mb: 1.5 }}
              >
                {nonCashMethods.length === 0 && (
                  <MenuItem value="" disabled>Belum ada metode, hubungi admin</MenuItem>
                )}
                {nonCashMethods.map((m) => (
                  <MenuItem key={m.uuid} value={m.uuid}>{m.name}</MenuItem>
                ))}
              </TextField>
              {(() => {
                const selectedMethod = nonCashMethods.find((m) => m.uuid === selectedNonCashMethodUuid);
                return selectedMethod?.imagePath ? (
                  <ZoomableImage
                    src={`${getApiBaseUrl()}/uploads/${selectedMethod.imagePath}`}
                    alt={selectedMethod.name}
                  />
                ) : null;
              })()}
            </Box>
          )}

          {selectedPaymentMethod === 'card' && (
            <Typography variant="body2" sx={{ color: '#6b778c', textAlign: 'center', py: 2 }}>
              Silakan gunakan mesin EDC di kasir
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button 
            onClick={tutupDialogBayar}
            disabled={paymentStatus === 'loading'}
          >
            Batal
          </Button>
          <Button
            variant="contained"
            onClick={
              selectedPaymentMethod === 'cash'
                ? processCashPayment
                : selectedPaymentMethod === 'qris'
                ? processQrisPayment
                : selectedPaymentMethod === 'noncash'
                ? processNonCashPayment
                : selectedPaymentMethod === 'bagi'
                ? processBagiPayment
                : selectedPaymentMethod === 'dp'
                ? processDpPayment
                : selectedPaymentMethod === 'reservasi'
                ? processReservasiPayment
                : () => {
                    setNotification({
                      open: true,
                      message: `Pembayaran ${selectedPaymentMethod.toUpperCase()} akan diproses di kasir`,
                      severity: 'info',
                    });
                    setPaymentDialogOpen(false);
                  }
            }
            disabled={
              (selectedPaymentMethod === 'cash' && (!customerCash || parseFloat(customerCash || 0) < total)) ||
              (selectedPaymentMethod === 'noncash' && !selectedNonCashMethodUuid) ||
              (selectedPaymentMethod === 'bagi' && !hitungBagi(total, bagi, nonCashMethods).sah) ||
              (selectedPaymentMethod === 'dp' && !hitungDp(total, dp, nonCashMethods).sah) ||
              (selectedPaymentMethod === 'reservasi' && !hitungReservasiBayar(total, reservasiBayar, reservasiDpList, nonCashMethods).sah) ||
              kuponBermasalah ||
              ['loading', 'qris_pending'].includes(paymentStatus)
            }
            sx={{ 
              bgcolor: POS_PRIMARY, 
              '&:hover': { bgcolor: POS_PRIMARY_HOVER },
              minWidth: 100
            }}
          >
            {paymentStatus === 'loading'
              ? 'Memproses...'
              : paymentStatus === 'qris_pending'
              ? 'Menunggu Pembayaran...'
              : 'Bayar'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={receiptPreviewOpen} onClose={() => setReceiptPreviewOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 900 }}>Preview Nota</DialogTitle>
        <DialogContent>
          {receiptPreviewData?.nomorAntrian && (
            <Box sx={{ textAlign: 'center', mb: 1 }}>
              <Typography sx={{ fontWeight: 900, fontSize: 28 }}>ANTRIAN {receiptPreviewData.nomorAntrian}</Typography>
              <Button size="small" startIcon={<CampaignOutlined />} onClick={() => panggilSuara(suaraDariLabel(receiptPreviewData.nomorAntrian, receiptPreviewData.namaCustomer))}>
                Panggil
              </Button>
            </Box>
          )}
          {receiptPreviewData && (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <StrukPratinjau baris={barisUntuk(receiptPreviewData)} />
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button onClick={() => setReceiptPreviewOpen(false)}>Tutup</Button>
          <Button variant="contained" onClick={() => printReceipt(receiptPreviewData)} disabled={isPrinting}>
            {isPrinting ? 'Mencetak...' : 'Print'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar notifikasi */}
      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification((p) => ({ ...p, open: false }))}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setNotification((p) => ({ ...p, open: false }))}
          severity={notification.severity}
          variant="filled"
          sx={{ borderRadius: 2 }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}